import { Button, Divider, Grid, IconButton, InputAdornment, Tooltip } from "@material-ui/core";
import { AddCircle } from "@material-ui/icons";
import DeleteIcon from '@material-ui/icons/Delete';
import CustomInput from "components/CustomInput";
import { vendorInvoiceStyles } from "../style";
import VehicleSelector from "components/VehicleSelector/VehicleSelector";
import { useState } from "react";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';


export const EditVendorVehicle = ({ onFieldChange, vehicleToEdit, selectedVehicle }) => {

    const isFormatted = vehicleToEdit?.isParsedFromInvoice;

    const formattedAdornment = (
        <InputAdornment position="end">
            <Tooltip title="Auto-detected from invoice">
                <InfoOutlinedIcon
                    fontSize="small"
                    color="primary"
                    style={{ opacity: 0.8, cursor: "default" }}
                />
            </Tooltip>
        </InputAdornment>
    );

    return (
        <>

            <Grid item xs={3}>
                <VehicleSelector
                    selectedVehicle={selectedVehicle}
                    onVehiclesChange={onFieldChange}
                    disableClearable={true}
                    error={!selectedVehicle?.vehicleId}
                />
            </Grid>
            <Grid item xs={3}>
                <CustomInput
                    disabled={true}
                    label="VIN"
                    value={vehicleToEdit?.vin}
                    elementType="input"
                    endAdornment={isFormatted ? formattedAdornment : null}
                />
            </Grid>
            <Grid item xs={2} >
                <CustomInput
                    disabled={true}
                    label="Make"
                    value={vehicleToEdit?.make}
                    elementType="input"
                    endAdornment={isFormatted ? formattedAdornment : null}
                />
            </Grid>
            <Grid item xs={1}>
                <CustomInput
                    disabled={true}
                    label="Model"
                    value={vehicleToEdit?.model}
                    elementType="input"
                    endAdornment={isFormatted ? formattedAdornment : null}
                />
            </Grid>
            <Grid item xs={2}>
                <CustomInput
                    disabled={true}
                    label="License Plate"
                    value={vehicleToEdit?.licensePlate}
                    elementType="input"
                    endAdornment={isFormatted ? formattedAdornment : null}
                />
            </Grid>
        </>
    );
};


const VendorInvoiceVehicles = ({ vehicles = [], onVehiclesChange }) => {
    const classes = vendorInvoiceStyles();
    const [vehicleList, setVehicleList] = useState(vehicles || []);

    const onAddVehicle = () => {
        setVehicleList([...vehicleList, {}]);
        if (onVehiclesChange) onVehiclesChange([...vehicleList, {}]);
    };

    const handleVehicleChange = (newVehicle, index) => {
        const updatedList = vehicleList.map((v, i) => {
            if (i !== index) return v;

            const hasFormattedData = v?.isParsedFromInvoice;

            return hasFormattedData
                ? {
                    ...v,
                    vehicleId: newVehicle.id,
                }
                : {
                    id: v.id || 0,
                    ...newVehicle,
                    vehicleId: newVehicle.id,
                    vin: newVehicle.descriptor
                };
        });

        setVehicleList(updatedList);
        if (onVehiclesChange) onVehiclesChange(updatedList);
    };


    const onDelete = (index) => {
        const updatedList = vehicleList.filter((_, i) => i !== index);
        setVehicleList(updatedList);
        if (onVehiclesChange) onVehiclesChange(updatedList);
    };

    return (
        <Grid container direction='column' spacing={1}>
            <Grid item><Divider /></Grid>
            <Grid item className={classes.serviceGroupLabel}>Vehicles</Grid>

            <Grid spacing={1} item xs={12} container className={classes.serviceHeaders}>
                <Grid item>
                    &nbsp;
                </Grid>
                <Grid item xs={3}>Vehicle</Grid>
                <Grid item xs={3}>VIN</Grid>
                <Grid item xs={2}>Make</Grid>
                <Grid item xs={1}>Model</Grid>
                <Grid item xs={2}>License Plate</Grid>
            </Grid>

            {vehicleList?.map((vehicle, index) => (
                <Grid spacing={1} item key={index} alignItems="center" container xs={12} className={classes.editServiceContainer}>
                    <Grid item >
                        <b>{index + 1}</b>
                    </Grid>
                    <EditVendorVehicle
                        onFieldChange={(newVehicle) => handleVehicleChange(newVehicle, index)}
                        vehicleToEdit={vehicle}
                        vehicles={vehicleList}
                        index={index}
                        selectedVehicle={vehicleList[index]}
                    />
                    <Grid item className={classes.serviceDropDownLine}>
                        <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => onDelete(index)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            ))}

            <Grid item>
                <Button
                    onClick={onAddVehicle}
                    startIcon={<AddCircle />}
                >
                    Add Vehicle
                </Button>
            </Grid>
        </Grid>
    );
};

export default VendorInvoiceVehicles;
